import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface CreateBooking {
	body: NonNullable<
		Api.Operations['createBooking']['requestBody']
	>['content']['application/json']
	response: Api.Operations['createBooking']['responses']['200']['content']['application/json']
}

export const createBooking = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<CreateBooking>(
		{
			method: 'post',
			url: '/bookings',
			...overideConfig,
		},
		axiosInstance,
	)
